import ReactDOM from 'react-dom/client';
import './index.scss';
import * as Sentry from '@sentry/react';
import init from './init';
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

Sentry.init({
  dsn: process.env.SENTRY_ADMSITE_DSN,
  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
  ],
  // The flag arrives as a string, and `"false"` is truthy — comparing it is the only way the
  // switch can actually turn Sentry off.
  enabled: process.env.SENTRY_ENABLED === 'true',
});

const app = async () => {
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  const vdom = await init();
  root.render(vdom);
};

app();
